export default __webpack_public_path__ + "static/media/p5.ad7f77bc.jpg";